import NewsResource from '@/common/resources/News'
import * as types from './types'
import AUTHOR_NICOLAS from '@/common/assets/img/authors/nicolas.jpg'
import AUTHOR_OLIVIER from '@/common/assets/img/authors/olivier.jpg'
import LOGO_PATRIMOFFICE from '@/common/assets/img/logo_short.png'
import UserStore from '@/store'

function getNewAuthorImage (authorInfo) {
	if (authorInfo.slug === 'olivier') {
		return AUTHOR_OLIVIER
	} else if (authorInfo.slug === 'nicolas') {
		return AUTHOR_NICOLAS
	}

	if (typeof authorInfo.avatar_urls['96'] !== 'undefined') {
		return authorInfo.avatar_urls['96']
	}

	return LOGO_PATRIMOFFICE
}

export const actions = {
	fetchAllNews ({ commit }) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			NewsResource.getAllNews().then((result) => {
				if (result.data.success) {
					commit(types.CLEAR_ARTICLES)
					result.data.news.forEach((article) => {
						const newsToAdd = {
							id: article.id,
							body: article.body,
							created_at: article.created_at,
							news_tags: article.news_tags,
							title: article.title,
							updated_at: article.updated_at,
							image: article.post_image_url,
							author: {
								name: article.user.first_name + ' ' + article.user.last_name,
								image: (article.user.media) ? process.env.ASSETS_ROOT + article.user.media.file : process.env.API_ROOT + '/assets/user.png'
							},
							link: article.post_url,
							size: 'small'
						}
						if (UserStore.getters.user.role === 'ADVISOR') {
							commit(types.ADD_MY_NEWS, newsToAdd)
						} else {
							commit(types.ADD_ARTICLE, newsToAdd)
						}
					})
					result.data.wp_news.forEach((article) => {
						// 61 = Wordpress id for banque
						const newsToAdd = {
							id: article.id,
							body: article.content.rendered,
							created_at: article.date,
							news_tags: article.tags,
							title: article.title.rendered,
							updated_at: article.modified,
							image: (article.better_featured_image) ? article.better_featured_image.source_url : null,
							author: {
								name: article._embedded.author[0].name,
								image: getNewAuthorImage(article._embedded.author[0])
							},
							size: 'big'
						}

						if (UserStore.getters.user.role === 'ADVISOR') {
							commit(types.ADD_ARTICLE, newsToAdd)
						} else {
							if (article.categories.indexOf(60) !== -1) {
								commit(types.ADD_ARTICLE, newsToAdd)
							} else {
								commit(types.ADD_BANQUE, newsToAdd)
							}
						}
					})
				}
				commit('LOADER_OUT')
				resolve()
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	shareNews ({ commit }, news) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			NewsResource.shareNews({
				title: news.title,
				body: news.body,
				post_url: news.link,
				post_image_url: news.link_image,
				date: new Date(),
				tags: news.selectedTags.map(tag => tag.id)
			}).then((result) => {
				if (result.data.success) {
					const article = result.data.article
					const newsToAdd = {
						id: article.id,
						body: article.body,
						created_at: article.created_at,
						news_tags: article.news_tags,
						title: article.title,
						updated_at: article.updated_at,
						image: article.post_image_url,
						author: {
							name: article.user.first_name + ' ' + article.user.last_name,
							image: (article.user.media) ? process.env.ASSETS_ROOT + article.user.media.file : process.env.API_ROOT + '/assets/user.png'
						},
						link: article.post_url,
						size: 'small'
					}
					commit(types.ADD_MY_NEWS, newsToAdd)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('je sais pas encore'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/common/store/News/actions.js